// HIDE DROPDOWN VAIRANTS
document.addEventListener('DOMContentLoaded', function() {
    const productForm = document.querySelector('form[action="/cart/add"]');
    if (!productForm) return;
  
    const sizeSelect = productForm.querySelector('#option-1');
    const colorSelect = productForm.querySelector('#option-2');
    const variantSelect = productForm.querySelector('[name="id"]');
    const priceElement = document.querySelector('.product-details__price');
    const addToCartButton = productForm.querySelector('.btn--atc');
  
    if (!sizeSelect || !colorSelect || !variantSelect || !priceElement || !addToCartButton) return;
  
    function initializeProductData(productData) {
      if (!productData || !productData.length) return;
  
      function styleUnavailableOptions(selectedSize) {
        Array.from(colorSelect.options).forEach(option => {
          if (option.value !== "") {
            let isAvailable = false;
            productData.forEach(variant => {
              const variantSize = variant.option1;
              const variantColor = variant.option2;
              if (variantSize === selectedSize && variantColor === option.value) {
                isAvailable = true;
              }
            });
            option.style.display = isAvailable ? 'block' : 'none';
          }
        });
      }
  
      function updateVariantVisibility() {
        const selectedSize = sizeSelect.value;
        const selectedColor = colorSelect.value;
  
        styleUnavailableOptions(selectedSize);
  
        variantSelect.innerHTML = '';
  
        let availableVariantExists = false;
  
        productData.forEach(variant => {
          const variantSize = variant.option1;
          const variantColor = variant.option2;
          const matches = variantSize === selectedSize && variantColor === selectedColor;
  
          if (matches) {
            const option = document.createElement('option');
            option.value = variant.id;
            option.text = `${variantSize} / ${variantColor} - £${(variant.price / 100).toFixed(2)} ${variant.available ? '' : '(Out of Stock)'}`;
            variantSelect.appendChild(option);
            if (variant.available) {
              availableVariantExists = true;
            }
          }
        });
  
        if (variantSelect.value) {
          const selectedVariant = productData.find(v => v.id === parseInt(variantSelect.value, 10));
          if (selectedVariant) {
            priceElement.textContent = `£${(selectedVariant.price / 100).toFixed(2)}`;
            priceElement.dispatchEvent(new Event('change'));
            addToCartButton.disabled = !selectedVariant.available;
          }
        } else {
          priceElement.textContent = '';
          addToCartButton.disabled = true;
        }
  
        if (!Array.from(colorSelect.options).find(option => option.value === selectedColor && option.style.display === 'block')) {
          colorSelect.value = "";
          variantSelect.innerHTML = '';
          addToCartButton.disabled = true;
          // The crucial change is here:
          setTimeout(() => {  // Use setTimeout to ensure the DOM is updated
            addToCartButton.disabled = true;
          }, 0);
        }
  
        if (!availableVariantExists) {
          addToCartButton.disabled = true;
        }
      }
  
      styleUnavailableOptions(sizeSelect.value);
      updateVariantVisibility();
  
      sizeSelect.addEventListener('change', function() {
        updateVariantVisibility();
        addToCartButton.disabled = true;
      });
  
      colorSelect.addEventListener('change', updateVariantVisibility);
    }
  
    const productDataScript = productForm.querySelector('script[data-app="esc-out-of-stock"]');
  
    if (productDataScript) {
      try {
        const productData = JSON.parse(productDataScript.textContent);
        initializeProductData(productData);
      } catch (error) {
        console.error("Error parsing JSON:", error);
      }
    } else {
      console.error("JSON data script not found.");
    }
  });
  // END HIDE DROPDOWN VARIANTS
  
  // HIDE RADIO VARIANTS
  // radio button variant
  document.addEventListener('DOMContentLoaded', function() {
    const productForm = document.querySelector('form[action="/cart/add"]');
    if (!productForm) return;
  
    const sizeSelect = productForm.querySelector('[name="Size"]');
    const colorSelect = productForm.querySelector('[name="Colour"]');
    const variantSelect = productForm.querySelector('[name="id"]');
    const priceElement = document.querySelector('.product-details__price');
    const addToCartButton = productForm.querySelector('.btn--atc');
  
    if (!sizeSelect || !colorSelect || !variantSelect || !priceElement || !addToCartButton) return;
  
    let productData;
  
    function initializeProductData(data) {
      productData = data;
      if (!productData || !productData.length) return;
  
      function styleUnavailableOptions(selectedSize) {
        productData.forEach(variant => {
          const variantSize = variant.option1;
          const variantColor = variant.option2;
  
          const sizeRadios = document.querySelectorAll('[name="Size"]');
          sizeRadios.forEach(radio => {
            const sizeLabel = radio.nextElementSibling;
            let sizeAvailable = false;
            productData.forEach(v => {
              if (v.option1 === radio.value) {
                sizeAvailable = true;
              }
            });
            sizeLabel.classList.toggle('peer-disabled:bg-[#F3F3F3]', !sizeAvailable);
            sizeLabel.classList.toggle('peer-disabled:text-[#b0b0b2]', !sizeAvailable);
            sizeLabel.classList.toggle('peer-disabled:line-through', !sizeAvailable);
            radio.disabled = !sizeAvailable;
          });
  
          const colorRadios = document.querySelectorAll('[name="Colour"]');
          colorRadios.forEach(radio => {
            const colorLabel = radio.nextElementSibling;
            let isAvailable = false;
            productData.forEach(v => {
              if (v.option1 === selectedSize && v.option2 === radio.value) {
                isAvailable = true;
              }
            });
  
            // Hide/show the *label* element:
            colorLabel.style.display = isAvailable ? 'flex' : 'none';
  
            // Keep the radio button disabled for form submission:
            radio.disabled = !isAvailable;
  
            //Update the styles based on availability
            colorLabel.classList.toggle('peer-disabled:bg-[#F3F3F3]', !isAvailable);
            colorLabel.classList.toggle('peer-disabled:text-[#b0b0b2]', !isAvailable);
            colorLabel.classList.toggle('peer-disabled:line-through', !isAvailable);
          });
        });
      }
  
      function updateVariantVisibility() {
        const selectedSize = document.querySelector('[name="Size"]:checked')?.value;
        const selectedColor = document.querySelector('[name="Colour"]:checked')?.value;
  
        if (!selectedSize || !selectedColor) {
          variantSelect.innerHTML = '';
          priceElement.textContent = '';
          addToCartButton.disabled = true;
          return; // Exit if no size or color is selected
        }
  
        styleUnavailableOptions(selectedSize);
  
        variantSelect.innerHTML = '';
        let availableVariantExists = false;
  
        productData.forEach(variant => {
          const matches = variant.option1 === selectedSize && variant.option2 === selectedColor;
  
          if (matches) {
            const option = document.createElement('option');
            option.value = variant.id;
            option.text = `${variant.option1} / ${variant.option2} - £${(variant.price / 100).toFixed(2)} ${variant.available ? '' : '(Out of Stock)'}`;
            variantSelect.appendChild(option);
            if (variant.available) {
              availableVariantExists = true;
            }
          }
        });
  
        if (variantSelect.value) {
          const selectedVariant = productData.find(v => v.id === parseInt(variantSelect.value, 10));
          if (selectedVariant) {
            priceElement.textContent = `£${(selectedVariant.price / 100).toFixed(2)}`;
            priceElement.dispatchEvent(new Event('change'));
            addToCartButton.disabled = !selectedVariant.available;
          }
        } else {
          priceElement.textContent = '';
          addToCartButton.disabled = true;
        }
        if (!availableVariantExists) {
          addToCartButton.disabled = true;
        }
      }
  
      styleUnavailableOptions(document.querySelector('[name="Size"]:checked')?.value);
      updateVariantVisibility();
  
      document.querySelectorAll('[name="Size"], [name="Colour"]').forEach(element => {
        element.addEventListener('change', updateVariantVisibility);
      });
    }
  
    const productDataScript = productForm.querySelector('script[data-app="esc-out-of-stock"]');
  
    if (productDataScript) {
      try {
        const data = JSON.parse(productDataScript.textContent);
        initializeProductData(data);
      } catch (error) {
        console.error("Error parsing JSON:", error);
      }
    } else {
      console.error("JSON data script not found.");
    }
  });
  // END HIDE RADIO VARIANTS